export default __webpack_public_path__ + "static/media/progress-circle-pause.452b3497.svg";